import { iphone } from './iphone';
import { ipad } from './ipad';
import { android } from './android';
import { macos } from './macos';
import { watchos } from './watchos';
import { web } from './web';

export { iphone, ipad, android, macos, watchos, web };

export const PLATFORMS = { iphone, ipad, android, macos, watchos, web };

/** Ordered list used for display and iteration */
export const PLATFORM_ORDER = ['iphone', 'ipad', 'watchos', 'macos', 'android', 'web'];

/** Grouped layout matching the screenshot UI */
export const PLATFORM_GROUPS = [
  {
    id: 'apple',
    label: 'iOS and macOS',
    platformIds: ['iphone', 'ipad', 'watchos', 'macos'],
  },
  {
    id: 'android',
    label: 'Android',
    platformIds: ['android'],
    hasFilenameOption: true,
  },
  {
    id: 'web',
    label: 'Web / PWA',
    platformIds: ['web'],
  },
];

/** The iOS asset-catalog folder shared by iphone + ipad */
export const IOS_FOLDER = 'ios/AppIcon.appiconset';

/** Platforms that share the iOS asset catalog (Contents.json) */
export const IOS_PLATFORM_IDS = ['iphone', 'ipad'];
